import { BenefitsAction } from "../../reducers/benefits/actionsNames";

export default function (benefits: number[]) {
  return {
    type: BenefitsAction.NewBenefits,
    benefits,
  };
}
